import { render } from "./TheExperimentalBar.vue?vue&type=template&id=5b2f33dc&scoped=true"
import script from "./TheExperimentalBar.vue?vue&type=script&lang=js"
export * from "./TheExperimentalBar.vue?vue&type=script&lang=js"

import "./TheExperimentalBar.vue?vue&type=style&index=0&id=5b2f33dc&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2f33dc"]])

export default __exports__